import Stack from '@mui/material/Stack'
import {useFormContext} from 'react-hook-form'
import PropTypes from 'prop-types'

const Form = ({onSubmit, children, id = 'form'}) => {
  const {handleSubmit} = useFormContext()

  return (
    <Stack id={id} autoComplete='off' component='form' onSubmit={handleSubmit(onSubmit)}>{children}</Stack>
  )
}

Form.propTypes = {
  onSubmit: PropTypes.func,
  children: PropTypes.node
}

export default Form
